import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * shadcn/ui's class helper. `clsx` resolves conditionals; `twMerge` then removes
 * conflicting Tailwind classes so a caller's `className` genuinely overrides the
 * component default instead of both landing in the class list and the winner
 * being decided by stylesheet order.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
